import type { GroupBase, StylesConfig } from "react-select";
import type { ListingDataTableColumn } from "../components/listing-data-table";
import type {
	CommunicationVehicle,
	CommunicationVehicleStatus,
} from "../types";

export const COMMUNICATION_PAGE_SIZE = 10;

export const COMMUNICATION_ILLUSTRATIONS = {
	emptySearch: "/tracking/communication-empty-search.svg",
	error: "/tracking/communication-error.svg",
} as const;

export const COMMUNICATION_STATUS_LABELS: Record<
	CommunicationVehicleStatus,
	string
> = {
	CONNECTED: "Conectado",
	DISCONNECTION: "Desconectado",
};

export const COMMUNICATION_TABLE_COLUMNS: ListingDataTableColumn<CommunicationVehicle>[] =
	[
		{ id: "groupName", label: "Grupo", minWidth: 160 },
		{ id: "plate", label: "Placa", minWidth: 140 },
		{ id: "model", label: "Modelo", minWidth: 160 },
		{ id: "status", label: "Status", minWidth: 140 },
		{
			id: "lastPosition",
			label: "Última comunicação",
			minWidth: 180,
			sortable: true,
		},
	];

type CommunicationSelectOption = {
	value: string;
	label: string;
};

export const COMMUNICATION_SELECT_STYLES: StylesConfig<
	CommunicationSelectOption,
	true,
	GroupBase<CommunicationSelectOption>
> = {
	control: (base, state) => ({
		...base,
		backgroundColor: "#ffffff",
		borderColor: state.isFocused ? "#9ca3af" : "#d1d5db",
		minHeight: "36px",
	}),
	dropdownIndicator: (base) => ({ ...base, padding: "6px" }),
	clearIndicator: (base) => ({ ...base, padding: "6px" }),
	placeholder: (base) => ({
		...base,
		color: "#6b7280",
	}),
	option: (base, { isFocused, isSelected }) => ({
		...base,
		backgroundColor: isFocused || isSelected ? "#e5e7eb" : "#ffffff",
		color: "#111827",
	}),
	menuPortal: (base) => ({ ...base, zIndex: 9999 }),
	menuList: (base) => ({
		...base,
		maxHeight:
			typeof window !== "undefined" && window.innerHeight < 600 ? 150 : 300,
		overflowY: "auto",
	}),
};
